<template>
	<cube-scroll ref="scroll" class="cube-scroll" :options="scrollOptions">
		<div class="direct-bind-wrapper">
			<div class="bind-type-wrapper">
				<div class="type-title">
					<div>1</div>
				</div>
				<article class="weui-article">
					<section>
						<p>请输入该停车券要绑定的车牌，车辆出入时，系统会自动找到该停车券。</p>
					</section>
				</article>

				<article class="weui-article" v-if="this.couponType == 10">
					<section>
						<div
							class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after">
							<div class="weui-cell__hd" style="color: #0d0d0d"><label class="weui-label">券时长</label>
							</div>

							<div class="weui-cell__bd" @click="chooseRationType">
								{{ checkedCoupon }}
							</div>
						</div>
					</section>
				</article>

				<article class="weui-article" v-if="this.couponType == 10">
					<section>
						<div
							class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after">
							<div class="weui-cell__hd" style="color: #0d0d0d"><label class="weui-label">车辆规则</label>
							</div>

							<div class="weui-cell__bd" @click="chooseFeescaleType">
								{{ feescaleCoupon }}
							</div>
						</div>
					</section>
				</article>


				<div ref="plateForm" class="weui-form-area">
					<div class="weui-cells weui-cells_form">
						<plate-input ref="plateInput1"></plate-input>
					</div>



					<div class="weui-btn-area">
						<button class="weui-btn weui-btn_warn" @click="checkParkHour">查询停车时长</button>
						<button class="weui-btn weui-btn_primary" @click="handleConfirm('plate')">确定</button>
					</div>

				</div>
			</div>

			<div class="bind-type-wrapper">
				<div class="type-title">
					<div>2</div>
				</div>
				<article class="weui-article">
					<section>
						<p>请输入该停车券要绑定账户的手机号码，系统会自动将停车券发放到手机号码对应的账户中</p>
					</section>
				</article>
				<div ref="telForm" class="weui-form-area" v-if="couponType != 9">
					<div class="weui-cells weui-cells_form">
						<div class="weui-cell weui-cell_vcode">
							<div class="weui-cell__hd">
								<label class="weui-label">手机号码</label>
							</div>
							<div class="weui-cell__bd">
								<input class="weui-input" type="tel" pattern="[0-9]{11}"
									v-model.trim="telForm.phonenumber" required notMatchTips="请输入正确的手机号"
									emptyTips="请输入号码" placeholder="请输入号码" @blur="blur">
							</div>
						</div>
						<div class="weui-cell weui-cell_vcode" v-if="couponType != 10">
							<div class="weui-cell__hd">
								<label class="weui-label">发放数量</label>
							</div>
							<div class="weui-cell__bd">
								<input class="weui-input" type="tel" v-model.trim="telForm.sendNum" required
									emptyTips="请输入数量" placeholder="请输入数量" @blur="blur">
							</div>
						</div>
					</div>
					<div class="weui-btn-area">
						<button class="weui-btn weui-btn_primary" @click="handleConfirm('phone')">确定</button>
					</div>
				</div>
			</div>
		</div>
	</cube-scroll>
</template>

<script>
import axios from 'axios'
import { validatePlate } from '@/utils/plateValidator'
import { sendCoupon, listFeescale } from '../../../api/coupon/directBind';
import { getRecordByPlateNo } from '../../../api/coupon/platePay'
import plateInput from '../components/plateInput'
import { mapGetters } from 'vuex'

export default {
	name: "index",
	data() {
		return {
			checkedCoupon: undefined,
			checkedCouponId: null,

			feescaleCoupon: undefined,
			feescaleId: null,
			feescaleList: [],

			durationId: null,
			id: undefined,
			couponType: undefined,
			parkinglotId: undefined,
			plateForm: {
				bindMethod: 2,
			},
			telForm: {
				bindMethod: 3,
			},
			scrollOptions: {
				click: true,
				bounce: false
			},
			checkedCouponOptions: [

				{
					value: '1',
					label: '一小时'
				},
				{
					value: '2',
					label: '二小时'
				},
				{
					value: '3',
					label: '三小时'
				},
				{
					value: '4',
					label: '四小时'
				},
				{
					value: '5',
					label: '五小时'
				},
				{
					value: '6',
					label: '六小时'
				},
				{
					value: '7',
					label: '七小时'
				},
				{
					value: '8',
					label: '八小时'
				},
				{
					value: '9',
					label: '九小时'
				},
				{
					value: '10',
					label: '十小时'
				},
				{
					value: '11',
					label: '十一小时'
				},
				{
					value: '12',
					label: '十二小时'
				},
				{
					value: '13',
					label: '十三小时'
				},
				{
					value: '14',
					label: '十四小时'
				},
				{
					value: '15',
					label: '十五小时'
				},
				{
					value: '16',
					label: '十六小时'
				},
				{
					value: '17',
					label: '十七小时'
				},
				{
					value: '18',
					label: '十八小时'
				},
				{
					value: '19',
					label: '十九小时'
				},
				{
					value: '20',
					label: '二十小时'
				},
				{
					value: '21',
					label: '二十一小时'
				},
				{
					value: '22',
					label: '二十二小时'
				},
				{
					value: '23',
					label: '二十三小时'
				},
				{
					value: '24',
					label: '二十四小时'
				},
			],

		}
	},
	components: {
		plateInput
	},
	computed: {
		...mapGetters(['userPhone', 'taskId'])
	},

	created() {
		console.log(this.$route.couponType, 'this.$route');

		this.id = this.taskId;
		this.parkinglotId = this.$route.params.parkinglotId;
		this.listFeescaleGet()
		this.couponType = this.$route.params.couponType;


		this.checkedCoupon = this.checkedCouponOptions[0].label;
		this.checkedCouponId = this.checkedCouponOptions[0].value;

	},
	methods: {
		listFeescaleGet() {
			listFeescale({ parkinglotId: this.parkinglotId }).then(res => {
				console.log(res, '123465789');
				// this.feescaleList = res.data


				let checkedCouponOptions = res.data;
				if (checkedCouponOptions.length > 0) {
					checkedCouponOptions.map(item => {
						item.label = item.platetypeName;
					});
					this.feescaleCoupon = checkedCouponOptions[0].platetypeName;
					this.feescaleId = checkedCouponOptions[0].id;
				} else {
					this.checkedCoupon = undefined;
					this.checkedCouponId = undefined;

				}
				this.feescaleList = checkedCouponOptions;

			})
		},
		chooseRationType() {
			this.$weui.picker(this.checkedCouponOptions, {
				onChange: result => {
					this.checkedCoupon = result[0].label;
					this.checkedCouponId = result[0].value;
				},
				onConfirm: result => {
					this.checkedCoupon = result[0].label;
					this.checkedCouponId = result[0].value;
				},
				// onClose: () => {
				//     this.userChooseCoupon()
				// },
				title: '可选优惠券'
			});
		},
		chooseFeescaleType() {
			this.$weui.picker(this.feescaleList, {

				onChange: result => {

					this.feescaleCoupon = result[0].platetypeName;
					this.feescaleId = result[0].id;
				},
				onConfirm: result => {
					this.feescaleCoupon = result[0].platetypeName;
					this.feescaleId = result[0].id;
				},
				// onClose: () => {
				//     this.userChooseCoupon()
				// },
				title: '车辆规则'
			});
		},

		getPlateNumber(data) {
			console.log('传值', data);
			this.$set(this.plateForm, 'platenumber', data);
		},
		blur() {
			window.scrollTo(0, 0)
		},
		/*验证输入框非空**/
		formValidate(form) {
			this.$weui.form.validate(form, error => {
				if (!error) {
					this.sendCouponByPhone()
				}
			})
		},
		handleConfirm(where) {
			let telForm = this.$refs['telForm'];
			if (where === 'plate') {//车牌
				// if (!this.$refs.plateInput1.getPlateNumber()) {
				// 	this.$weui.alert('请输入正确的车牌号')
				// 	return
				// }
				this.plateForm.platenumber = this.$refs.plateInput1.getPlateNumber();
				if (validatePlate(this.$refs.plateInput1.getPlateNumber()).valid) {
					console.log(this.couponType, 'this.couponType ');
					if (this.couponType == 9) {
						console.log(this.durationId, 'this.durationId');
						if (this.durationId) {
							this.sendCouponByPlate()
						} else {
							this.$weui.alert('此优惠券类型请先点击查询停车时长')
						}

					} else if (this.couponType == 10) {

						if (this.checkedCouponId) {
							this.sendCouponByPlate()
						} else {
							this.$weui.alert('此优惠券类型请选择券时间')
						}
					} else {
						this.sendCouponByPlate()
					}


				} else {
					this.$weui.alert('车牌号格式错误！')
				}
			} else if (where === 'phone') {
				this.formValidate(telForm, where)
			}
		},
		/*通过车牌号发券**/
		sendCouponByPlate() {
			this.$set(this.plateForm, 'businessPhone', this.userPhone);
			this.$set(this.plateForm, 'couponTaskId', this.id);

			if (this.couponType == 9) {
				this.$set(this.plateForm, 'recId', this.durationId);
			}
			if (this.couponType == 10) {
				let validateTime = this.checkedCouponId * 60

				this.$set(this.plateForm, 'validateTime', validateTime);
				console.log(this.feescaleId, 'this.feescaleId');
				this.$set(this.plateForm, 'feescaleId', this.feescaleId);
			}
			this.sendCoupon(this.plateForm)
		},
		/*通过手机号发券**/
		sendCouponByPhone() {
			this.$set(this.telForm, 'businessPhone', this.userPhone);
			this.$set(this.telForm, 'couponTaskId', this.id);
			if (this.couponType == 9) {
				this.$set(this.telForm, 'recId', this.durationId);
			}
			if (this.couponType == 10) {
				let validateTime = this.checkedCouponId * 60

				this.$set(this.telForm, 'validateTime', validateTime);

				this.$set(this.telForm, 'feescaleId', this.feescaleId);
			}
			this.sendCoupon(this.telForm)
		},
		/*调用发券接口**/
		sendCoupon(form) {
			sendCoupon(form).then(res => {
				if (res.code === 200) {
					this.$weui.alert("绑定成功，您可以在本页面继续绑定，直到该类停车券全部被绑定。");
				}
			})
		},
		/**查询车停车时长**/
		checkParkHour() {
			if (validatePlate(this.$refs.plateInput1.getPlateNumber()).valid) {
				getRecordByPlateNo({ plateno: this.$refs.plateInput1.getPlateNumber(), parkinglotId: this.parkinglotId }).then(res => {
					if (res.code === 200) {
						this.durationId = res.data.id
						this.$weui.alert("该车停车时长: " + res.data.parkHours);
					}
				});
			} else {
				this.$weui.alert('车牌号格式错误！')
			}
		}
	}
}
</script>

<style scoped lang="stylus">
	@import '~common/stylus/variable';
	.weui-cell_select-after.weui-cell_access .weui-cell__bd{
		line-height 0px
		font-size 15px
	}
	.cube-scroll{
		position: relative;
		text-align: left;
		white-space: normal;
		max-height: 100%
		overflow hidden
		/*background: #ffffff;*/
		margin-bottom 30px
		.bind-type-wrapper {
			padding-top 20px
			.type-title {
				color #F43430
				font-size $article-p
				text-align center
				display flex
				div {
					width 10px
					height 10px
					line-height 10px
					text-align center
					font-weight 500
					padding 3px
					border-radius 50%
					border 1px solid #F43430
					margin auto
				}
			}
			.weui-article {
				padding-top 10px
				padding-bottom 0
				p {
					color $article-merchant-p
					font-size $article-merchant-p
					line-height 20px
				}
			}
			.weui-cells {
				.weui-cell {
					padding 15px
				}
			}
			.weui-btn-area {
				margin-top 20px
				.weui-btn {
					width: 100%;
				}
				p {
					font-size $article-p
					color $article-merchant-p
					line-height 20px
					padding-top 10px
				}
			}
		}
	}
</style>
